export default __webpack_public_path__ + "static/media/BGMusic.f302d3b7.mp3";